import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './local/index.js';
import { getImageUrl } from '@/utils/imageUrl';
import { getCdnUrl } from '@/api/app';

Vue.prototype.getImageUrl = getImageUrl;
Vue.prototype.$getAssetUrl = getImageUrl;

// 启动时获取OSS CDN域名和服务器域名并缓存
getCdnUrl().then(res => {
    if (res && res.data && res.data.code == 1) {
        const d = res.data.data;
        localStorage.setItem('cdn_url', d.cdn_url || '');
        localStorage.setItem('server_url', d.server_url || '');
        localStorage.setItem('upload_mode', d.mode || 'local');
    }
}).catch(() => {});

import ElementUI from 'element-ui';

// 动画
import './styles/element-variables.scss';
import '@/assets/css/common.css';
import 'animate.css';

// SEO插件
import MetaInfo from 'vue-meta-info';
Vue.use(MetaInfo)

// 公共组件
import MyNav from '@/components/MyNav';
Vue.component('MyNav', MyNav);
import MyFooter from '@/components/MyFooter';
Vue.component('MyFooter', MyFooter);
import SonBanner from '@/components/SonBanner';
Vue.component('SonBanner', SonBanner);
import LeftNav from '@/components/LeftNav';
Vue.component('LeftNav', LeftNav);
import MyLeft from '@/components/MyLeft';
Vue.component('MyLeft', MyLeft);

Vue.use(ElementUI)

Vue.config.productionTip = false


new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
